// 4스텝 구조 - 각 스텝별 이미지 클릭 시 변경
// 스텝1: 02 클릭→04, 03 클릭→05
// 스텝2,3: 02 클릭→06, 03 클릭→07, 04 클릭→08, 05 클릭→09
// 스텝4: 최종 폼 제출

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleFormSubmit } from "../handlers/formHandlers";
import { validateName, validatePhoneNumber } from "../utils/validation";
import { prohibitedWords } from "../utils/dummyData";
import BenefitPeriod from "../components/BenefitPeriod";

import "./randingStyle26.scss";
import PrivacyContent from "./PrivacyContent";
import { buildPrivacyNewFormHtml } from "./privacyNewForm";
import RandingConsent from "./RandingConsent";

function RandingStyle26({
  urlCode,
  urlCodeSettingId,
  imageFolderPath,
  keepBTN,
  postBTN,
  companyName,
  privacyCompanyName,
  footerPath,
  apiUrl,
  privacyMessage,
  kakaotalk,
  carrotTag,
  customFooter,
  footerData,
  altTexts,
  optionLabels,
  autoNextOnSelect,
  footerStyle,
  privacyNewForm,
  privacySheet,
  privacyTrustee,
}) {
  const navigate = useNavigate();
  const privacyName = privacyCompanyName || companyName || "수집주체명";

  // 상태 관리
  const [currentStep, setCurrentStep] = useState(1);
  const [name, setName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState({
    first: "",
    second: "",
    third: "",
  });
  const [isAgreed, setIsAgreed] = useState(false);
  const [isMarketingAgreed, setIsMarketingAgreed] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);

  // 각 스텝별 클릭 상태 (이미지 변경 여부)
  const [step1Clicked, setStep1Clicked] = useState({
    left: false, // 02 클릭됨 → 04 표시
    right: false, // 03 클릭됨 → 05 표시
  });

  const [step2Clicked, setStep2Clicked] = useState({
    left1: false, // 02 클릭됨 → 06 표시
    right1: false, // 03 클릭됨 → 07 표시
    left2: false, // 04 클릭됨 → 08 표시
    right2: false, // 05 클릭됨 → 09 표시
  });

  const [step3Clicked, setStep3Clicked] = useState({
    left1: false,
    right1: false,
    left2: false,
    right2: false,
  });

  // 유효성 검사
  const validateInput = () => {
    return (
      validateName(name, prohibitedWords) && validatePhoneNumber(phoneNumber)
    );
  };

  // 이벤트 핸들러
  const handlePhoneNumberChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, "");

    setPhoneNumber((prev) => ({
      ...prev,
      [name]: numericValue,
    }));
  };

  const nextStep = () => {
    if (currentStep < 4) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleSubmit = () => {
    let selectedOption = "";

    if (optionLabels) {
      // 새로운 형식: 선택된 항목만 쉼표로 구분
      const selected = [];

      // 스텝1 처리
      if (step1Clicked.left && optionLabels.step1?.left) {
        selected.push(optionLabels.step1.left);
      }
      if (step1Clicked.right && optionLabels.step1?.right) {
        selected.push(optionLabels.step1.right);
      }

      // 스텝2 처리
      if (step2Clicked.left1 && optionLabels.step2?.left1) {
        selected.push(optionLabels.step2.left1);
      }
      if (step2Clicked.right1 && optionLabels.step2?.right1) {
        selected.push(optionLabels.step2.right1);
      }
      if (step2Clicked.left2 && optionLabels.step2?.left2) {
        selected.push(optionLabels.step2.left2);
      }
      if (step2Clicked.right2 && optionLabels.step2?.right2) {
        selected.push(optionLabels.step2.right2);
      }

      // 스텝3 처리
      if (step3Clicked.left1 && optionLabels.step3?.left1) {
        selected.push(optionLabels.step3.left1);
      }
      if (step3Clicked.right1 && optionLabels.step3?.right1) {
        selected.push(optionLabels.step3.right1);
      }
      if (step3Clicked.left2 && optionLabels.step3?.left2) {
        selected.push(optionLabels.step3.left2);
      }
      if (step3Clicked.right2 && optionLabels.step3?.right2) {
        selected.push(optionLabels.step3.right2);
      }

      selectedOption = selected.join(", ");
    } else {
      // 기존 형식 유지 (하위 호환성)
      selectedOption = `스텝1:좌${step1Clicked.left ? "선택" : "미선택"}/우${
        step1Clicked.right ? "선택" : "미선택"
      }, 스텝2:좌1-${step2Clicked.left1 ? "선택" : "미선택"}/우1-${
        step2Clicked.right1 ? "선택" : "미선택"
      }/좌2-${step2Clicked.left2 ? "선택" : "미선택"}/우2-${
        step2Clicked.right2 ? "선택" : "미선택"
      }, 스텝3:좌1-${step3Clicked.left1 ? "선택" : "미선택"}/우1-${
        step3Clicked.right1 ? "선택" : "미선택"
      }/좌2-${step3Clicked.left2 ? "선택" : "미선택"}/우2-${
        step3Clicked.right2 ? "선택" : "미선택"
      }`;
    }

    handleFormSubmit({
      name,
      phoneNumber,
      selectedOption,
      isAgreed,
      submitCount,
      setSubmitCount,
      validateInput,
      urlCode,
      urlCodeSettingId,
      navigate,
      setIsSubmitting,
      apiUrl,
      kakaotalk,
      carrotTag,
    });
  };

  // 이미지 경로 생성 헬퍼
  const getImagePath = (step, imageNum) => {
    return `${imageFolderPath}/${step}/${imageNum}.png`;
  };

  return (
    <div className="form-container randing-style-26">
      {/* 스텝 1 */}
      {currentStep === 1 && (
        <div className="step step1">
          <div className="main-image-wrapper">
            <img src={getImagePath(1, "01")} alt={altTexts?.step1 || "스텝1 메인 이미지"} />

            <div className="button-group">
              <div className="choice-buttons">
                {/* 왼쪽: 02 또는 04 (둘 중 하나만 선택 가능) */}
                <img
                  src={getImagePath(1, step1Clicked.left ? "04" : "02")}
                  alt="왼쪽 선택"
                  onClick={() => {
                    setStep1Clicked({
                      left: !step1Clicked.left,
                      right: false,
                    });
                    if (autoNextOnSelect) setTimeout(() => nextStep(), 300);
                  }}
                />
                {/* 오른쪽: 03 또는 05 */}
                <img
                  src={getImagePath(1, step1Clicked.right ? "05" : "03")}
                  alt="오른쪽 선택"
                  onClick={() => {
                    setStep1Clicked({
                      left: false,
                      right: !step1Clicked.right,
                    });
                    if (autoNextOnSelect) setTimeout(() => nextStep(), 300);
                  }}
                />
              </div>
            </div>
          </div>

          {!autoNextOnSelect && (
            <div className="keep-btn">
              <img src={keepBTN} alt="계속하기" onClick={nextStep} />
            </div>
          )}
        </div>
      )}

      {/* 스텝 2 */}
      {currentStep === 2 && (
        <div className="step step2">
          <div className="main-image-wrapper">
            <img src={getImagePath(2, "01")} alt={altTexts?.step2 || "스텝2 메인 이미지"} />

            <div className="button-group">
              {/* 첫 번째 쌍 */}
              <div className="choice-buttons">
                <img
                  src={getImagePath(2, step2Clicked.left1 ? "06" : "02")}
                  alt="왼쪽 선택1"
                  onClick={() => {
                    setStep2Clicked({
                      ...step2Clicked,
                      left1: !step2Clicked.left1,
                    });
                    if (autoNextOnSelect) setTimeout(() => nextStep(), 300);
                  }}
                />
                <img
                  src={getImagePath(2, step2Clicked.right1 ? "07" : "03")}
                  alt="오른쪽 선택1"
                  onClick={() => {
                    setStep2Clicked({
                      ...step2Clicked,
                      right1: !step2Clicked.right1,
                    });
                    if (autoNextOnSelect) setTimeout(() => nextStep(), 300);
                  }}
                />
              </div>

              {/* 두 번째 쌍 */}
              <div className="choice-buttons">
                <img
                  src={getImagePath(2, step2Clicked.left2 ? "08" : "04")}
                  alt="왼쪽 선택2"
                  onClick={() => {
                    setStep2Clicked({
                      ...step2Clicked,
                      left2: !step2Clicked.left2,
                    });
                    if (autoNextOnSelect) setTimeout(() => nextStep(), 300);
                  }}
                />
                <img
                  src={getImagePath(2, step2Clicked.right2 ? "09" : "05")}
                  alt="오른쪽 선택2"
                  onClick={() => {
                    setStep2Clicked({
                      ...step2Clicked,
                      right2: !step2Clicked.right2,
                    });
                    if (autoNextOnSelect) setTimeout(() => nextStep(), 300);
                  }}
                />
              </div>
            </div>
          </div>

          {!autoNextOnSelect && (
            <div className="keep-btn">
              <img src={keepBTN} alt="계속하기" onClick={nextStep} />
            </div>
          )}
        </div>
      )}

      {/* 스텝 3 */}
      {currentStep === 3 && (
        <div className="step step3">
          <div className="main-image-wrapper">
            <img src={getImagePath(3, "01")} alt={altTexts?.step3 || "스텝3 메인 이미지"} />

            <div className="button-group">
              {/* 첫 번째 쌍 */}
              <div className="choice-buttons">
                <img
                  src={getImagePath(3, step3Clicked.left1 ? "06" : "02")}
                  alt="왼쪽 선택1"
                  onClick={() => {
                    setStep3Clicked({
                      ...step3Clicked,
                      left1: !step3Clicked.left1,
                    });
                    if (autoNextOnSelect) setTimeout(() => nextStep(), 300);
                  }}
                />
                <img
                  src={getImagePath(3, step3Clicked.right1 ? "07" : "03")}
                  alt="오른쪽 선택1"
                  onClick={() => {
                    setStep3Clicked({
                      ...step3Clicked,
                      right1: !step3Clicked.right1,
                    });
                    if (autoNextOnSelect) setTimeout(() => nextStep(), 300);
                  }}
                />
              </div>

              {/* 두 번째 쌍 */}
              <div className="choice-buttons">
                <img
                  src={getImagePath(3, step3Clicked.left2 ? "08" : "04")}
                  alt="왼쪽 선택2"
                  onClick={() => {
                    setStep3Clicked({
                      ...step3Clicked,
                      left2: !step3Clicked.left2,
                    });
                    if (autoNextOnSelect) setTimeout(() => nextStep(), 300);
                  }}
                />
                <img
                  src={getImagePath(3, step3Clicked.right2 ? "09" : "05")}
                  alt="오른쪽 선택2"
                  onClick={() => {
                    setStep3Clicked({
                      ...step3Clicked,
                      right2: !step3Clicked.right2,
                    });
                    if (autoNextOnSelect) setTimeout(() => nextStep(), 300);
                  }}
                />
              </div>
            </div>
          </div>

          {!autoNextOnSelect && (
            <div className="keep-btn">
              <img src={keepBTN} alt="계속하기" onClick={nextStep} />
            </div>
          )}
        </div>
      )}

      {/* 스텝 4 - 최종 폼 */}
      {currentStep === 4 && (
        <div className="step step4">
          <div className="main-image-wrapper">
            <img src={getImagePath(4, "01")} alt={altTexts?.step4 || "스텝4 메인 이미지"} />

            <div className="form-overlay">
              <form
                className="simple-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSubmit();
                }}
              >
                <input
                  type="text"
                  placeholder="이름"
                  maxLength="10"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />

                <input
                  type="tel"
                  placeholder="연락처"
                  value={`${phoneNumber.first}${phoneNumber.second}${phoneNumber.third}`}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    if (value.length <= 11) {
                      const first = value.substring(0, 3);
                      const second = value.substring(3, 7);
                      const third = value.substring(7, 11);
                      setPhoneNumber({ first, second, third });
                    }
                  }}
                  maxLength="11"
                  required
                />
              </form>
            </div>
          </div>

          <p className="benefitInfo">
            <BenefitPeriod />
            <br />
            이벤트 대상자 : 해당 매체 이용자
          </p>

          <RandingConsent
            isAgreed={isAgreed}
            setIsAgreed={setIsAgreed}
            isMarketingAgreed={isMarketingAgreed}
            setIsMarketingAgreed={setIsMarketingAgreed}
            companyName={privacyName}
            privacyContent={
              privacyNewForm ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: buildPrivacyNewFormHtml({
                      hospital: privacyName,
                      trustee: privacyTrustee,
                    }),
                  }}
                />
              ) : (
                <PrivacyContent companyName={privacyName} />
              )
            }
          />

          <div className="post-btn">
            <img
              src={postBTN}
              alt="신청하기"
              onClick={handleSubmit}
              style={{ cursor: 'pointer' }}
            />
          </div>

        </div>
      )}

      <div className="footer" style={footerStyle}>
        {customFooter && footerData ? (
          <div className="custom-footer">
            <p className="footer-line1">{footerData.line1}</p>
            <p className="footer-line2">{footerData.line2}</p>
            <p className="footer-line3">{footerData.line3}</p>
          </div>
        ) : (
          footerPath && <img src={footerPath} alt="푸터" />
        )}
      </div>
    </div>
  );
}

export default RandingStyle26;
